export const DISPLAY_AS = {
  COUNT: { label: 'Count', value: 'count' },
  PERCENT: { label: 'Percentages', value: 'pct' },
};

export const DISPLAY_AS_OPTIONS = [DISPLAY_AS.PERCENT, DISPLAY_AS.COUNT];

export const sanitizeQuestionText = (text) => {
  if (!text || typeof text !== 'string') return text;
  return text
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s*\[concept_image\]\s*/gi, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};
